import { fetchCategoryTabsQuery } from 'app/features/offer/containers/category-tabs/queries'
import { OffersScreen } from 'app/features/offer/screens'
import { dedupeDiscountsIds } from 'app/features/offer/screens/offers-screen/lib/dedupe-discounts-ids'
import {
  fetchDiscountHomeQuery,
  fetchDiscountsHomeOffersQuery,
} from 'app/features/offer/screens/offers-screen/queries'
import { addApolloState, initializeApollo } from 'lib/initialize-apollo'
import { withAuthedPage } from 'lib/session'
import { GetServerSideProps } from 'next'
import Head from 'next/head'

export default function Page(props: any) {
  return (
    <>
      <Head>
        <meta name="fo-verify" content="f38e0792-39e1-445a-9154-f82817957a4d" />
      </Head>
      <OffersScreen {...props} />
    </>
  )
}

export const getServerSideProps: GetServerSideProps = withAuthedPage(
  async ({ req, res, query }) => {
    const user = req?.session?.user
    const draft = !!query?.preview

    const client = initializeApollo({
      token: user?.token,
      previewToken: query?.token as string,
    })

    const [discountsData] = await Promise.all([
      client.query({
        query: fetchDiscountHomeQuery.query,
        variables: {
          draft,
        },
      }),
      client.query({
        query: fetchCategoryTabsQuery.query,
      }),
    ])

    const dedupeIds = dedupeDiscountsIds(discountsData?.data?.DiscountsHome?.content || [])

    await client.query({
      query: fetchDiscountsHomeOffersQuery.query,
      variables: {
        page: 1,
        limit: 6,
        dedupeIds,
      },
    })

    // add cache headers if not authenticated
    if (!user) {
      res.setHeader('Cache-Control', 's-maxage=60, stale-while-revalidate')
    }

    return addApolloState(client, {
      props: {
        user: user || null,
        preview: draft,
      },
    })
  }
)
